"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isImageCaptionFlagProperty = exports.imageCaptionFlagPropertyDefinition = void 0;
exports.imageCaptionFlagPropertyDefinition = {
    view: { label: 'Image contains caption' },
    constraints: [],
    type: 'boolean',
    multiple: false,
    default: false,
    name: 'image-caption-flag',
};
const isImageCaptionFlagProperty = (prop) => {
    return prop.name === exports.imageCaptionFlagPropertyDefinition.name;
};
exports.isImageCaptionFlagProperty = isImageCaptionFlagProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1hZ2UtY2FwdGlvbi1mbGFnLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvaW1hZ2UtY2FwdGlvbi1mbGFnLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsa0NBQWtDLEdBQUc7SUFDaEQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLHdCQUF3QixFQUFFO0lBQ3pDLFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLFNBQVM7SUFDZixRQUFRLEVBQUUsS0FBSztJQUNmLE9BQU8sRUFBRSxLQUFLO0lBQ2QsSUFBSSxFQUFFLG9CQUFvQjtDQUNLLENBQUE7QUFJMUIsTUFBTSwwQkFBMEIsR0FBRyxDQUFDLElBQWtCLEVBQW9DLEVBQUU7SUFDakcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDBDQUFrQyxDQUFDLElBQUksQ0FBQTtBQUM5RCxDQUFDLENBQUE7QUFGWSxRQUFBLDBCQUEwQiw4QkFFdEMifQ==